export default {"src":"/_next/static/media/emc.462fa350.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};